export default {
  EXAM_RESULTS: "exams/results",
  EXAM_CENTERS: "exams/centers",
  PROGRAMME_REGISTRATION: "student/programme-registration",
  EXAM_BOOKINGS: "exams/booking",
  EXAM_TRANSCRIPT: "exams/results/transcript",
  getHistoricalTranscript: "exams/results/getHistoricalTranscript",
  booking: "exams/booking/book",
  proforma: (transactionID) =>
    `cu/PEGASUS_CU/SchoolManagement_getRegistrationProfomaInvoice?transactionNo=${transactionID}`,
  receipt: (id) =>
    `cu/PEGASUS_CU/SchoolManagement_getReceiptReport?receiptNo=${id}`,
  notes: (unitCode) =>
    `cu/PEGASUS_CU/SchoolManagement_getUnitNotes?unitCode=${unitCode}`,
  UNITS: "setup/programmes",
};
